// app/javascript/controllers/consult_form_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["modal", "form", "submitButton", "error", "formContent", "successContent", "openButton", "alreadyRequested"]

    connect() {
        document.addEventListener('keydown', this.handleEscape.bind(this))
    }

    disconnect() {
        document.removeEventListener('keydown', this.handleEscape.bind(this))
    }

    open() {
        this.modalTarget.classList.remove('hidden')
        document.body.classList.add('overflow-hidden')
    }

    close() {
        this.modalTarget.classList.add('hidden')
        document.body.classList.remove('overflow-hidden')
        this.resetForm()
    }

    resetForm() {
        this.formTarget.reset()
        this.hideError()
        this.formContentTarget.classList.remove('hidden')
        this.successContentTarget.classList.add('hidden')
    }

    hideError() {
        this.errorTarget.classList.add('hidden')
    }

    showError(message) {
        this.errorTarget.textContent = message
        this.errorTarget.classList.remove('hidden')
    }

    async submit(event) {
        event.preventDefault()

        if (!this.formTarget.checkValidity()) {
            this.showError("Bitte füllen Sie alle Pflichtfelder aus.")
            return
        }

        this.submitButtonTarget.disabled = true
        this.submitButtonTarget.innerHTML = 'Wird gesendet...'
        this.openButtonTarget.disabled = true
        this.openButtonTarget.classList.add('opacity-50')
        this.alreadyRequestedTarget.classList.remove('hidden')

        try {
            const formData = new FormData(this.formTarget)

            const response = await fetch('/pflegegrad_rechner/submit_consult_request', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({
                    consultation_token: formData.get('consultationToken'),
                    first_name: formData.get('firstName'),
                    last_name: formData.get('lastName'),
                    phone: formData.get('phone')
                })
            })

            if (!response.ok) {
                throw new Error('Network response was not ok')
            }

            this.showSuccess()
        } catch (error) {
            console.error('Submission error:', error)
            this.showError("Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.")
            this.submitButtonTarget.disabled = false
            this.submitButtonTarget.innerHTML = 'Beratung anfordern'
        }
    }

    showSuccess() {
        this.formContentTarget.classList.add('hidden')
        this.successContentTarget.classList.remove('hidden')
    }

    handleEscape(event) {
        if (event.key === 'Escape' && !this.modalTarget.classList.contains('hidden')) {
            this.close()
        }
    }

    clickOutside(event) {
        if (event.target === this.modalTarget) {
            this.close()
        }
    }
}
